import Layout from "../../../layout/Layout";
import React, { useRef, useEffect, useState } from "react";
import { Container } from "@mui/system";
import {
  Button,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Autocomplete,
  FormGroup,
  FormControl,
  FormControlLabel,
  InputLabel,
  Switch,
  Select,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Backdrop,
  CircularProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";

import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
  timelineOppositeContentClasses,
} from "@mui/lab";
import DownloadIcon from "@mui/icons-material/Download";
import UserAvatar from "../../../components/UserAvatar";
import {
  ExpandMore as ExpandMoreIcon,
  Reply as ReplyIcon,
  Description as DescriptionIcon,
  Send as SendIcon,
} from "@mui/icons-material";
import {
  agentDashboardAPI,
  assetsAPI,
  config,
  ticketAPI,
  userDashboardAPI,
  userData,
  baseURL1,
  statusAPI,
} from "../../../config";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment/moment";
import { AlertMessage } from "../../../components/AlertMessage";
import { TextEditor, getInnerHtml, addContentTo } from "text-editor-react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

let intIssueSubType = 0;

export default function AgentUpdateTicket() {
  const { ticketID, ticketDescription } = useParams();
  const [expanded, setExpanded] = React.useState("panel1");
  const [vendorNameError, setVendorNameError] = React.useState("");
  const [intAgentID, setAgentID] = React.useState("");
  const [txtDescription, setDescription] = React.useState("");
  const [contactDetails, setContactDetails] = React.useState({});
  const [timelineList, setTimelineList] = React.useState([]);
  const [agentList, setAgentList] = React.useState([]);

  const [intSubCategory, setSubCategory] = React.useState(0);
  const [intVendorID, setVendorID] = React.useState(0);
  const [isReplying, setIsReplying] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [declineReason, setDeclineReason] = useState("");
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [selectedStatusID, setSelectedStatusID] = useState(null);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [files, setFiles] = useState([]);
  const [fileNames, setFileNames] = useState([]);

  function handleFileChange(event) {
    if (event.target.files.length > 0) {
      setFiles((prev) => [...prev, ...Array.from(event.target.files)]);
    }
  }

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const [toggleState, setToggleState] = React.useState(false);

  const handleToggleChange = () => {
    if (toggleState) {
      setVendorDescription("");
      setVendorAttachment("");
    }
    setToggleState(!toggleState);
  };

  const [ticketData, setTicketData] = useState([]);
  const [vendorName, setVendorName] = useState("");
  const [txtVendorDescription, setVendorDescription] = useState("");
  const [txtVendorAttachment, setVendorAttachment] = useState("");

  const [issueTypeList, setIssueTypeList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [ticketStatusList, setTicketStatusList] = useState([]);
  const [repetedTicketStatusList, setRepetedTicketStatusList] = useState([]);
  const [statusDataList, setStatusDataList] = useState([]);

  const [openFeedback, setOpenFeedback] = useState(false);
  const [feedbackValue, setFeedbackValue] = useState(0);

  let updateRef = useRef(false);

  let assetsRef = useRef(false);
  useEffect(() => {
    if (assetsRef.current === false) {
      addContentTo("", "txtDescription");
      let data = JSON.stringify({
        intUserID: userData.id,
        intTicketID: parseInt(ticketID),
        intSPType: 3,
      });
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          console.log(
            response.data["data"][0].ticket_attachment.replace(".", baseURL1),
            "130"
          );
          setTicketData(response.data["data"]);
          setVendorAttachment(
            response.data["data"][0].ticket_attachment.replace(".", baseURL1)
          );
          setVendorName(
            response.data["data"][0].vendor_name === null
              ? ""
              : response.data["data"][0].vendor_name
          );
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        intUserID: userData.id,
        intTicketID: parseInt(ticketID),
        intSPType: 5,
      });
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          setContactDetails(response.data["data"][0]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        intUserID: userData.id,
        intTicketID: parseInt(ticketID),
        intSPType: 6,
      });
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          setTimelineList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        intTicketID: parseInt(ticketID),
        intSPType: 13,
      });
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          setVendorList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        intTicketID: parseInt(ticketID),
        intUserID: userData.id,
        intSPType:
          userData.departmenthead === 1 || userData.role === "Admin" ? 23 : 24,
      });

      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;

      axios(config)
        .then(function (response) {
          const result = response.data?.data;
          if (result) {
            if (Array.isArray(result)) {
              setStatusDataList(result);
            }
          }
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.error(error);
        });

      data = JSON.stringify({
        intTicketID: parseInt(ticketID),
        intSPType: 16,
      });
      config.method = "PATCH";
      config.data = data;
      config.url = agentDashboardAPI;
      axios(config)
        .then(function (response) {
          setAgentList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        parent_id: 43,
      });

      config.method = "patch";
      config.url = statusAPI;
      config.data = data;

      axios(config)
        .then(function (response) {
          setTicketStatusList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        parent_id: 176,
      });

      config.method = "patch";
      config.url = statusAPI;
      config.data = data;

      axios(config)
        .then(function (response) {
          setRepetedTicketStatusList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      return () => {
        assetsRef.current = true;
      };
    }
  }, []);

  const childRef = useRef();
  const handleAssignAgent = () => {
    console.log(ticketID);
    console.log(intAgentID);
    const data = JSON.stringify({
      intAgentID: parseInt(intAgentID),
      intTicketID: parseInt(ticketID),
      intUserID: userData.id,
      intSPType: 17,
    });
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    axios(config)
      .then(function (response) {
        if (
          response.data.message ===
          "Please choose another IT admin, You are trying to assign an existing IT admin"
        ) {
          childRef.current.triggerAlert(
            JSON.stringify({
              message:
                "Please choose another IT admin, You are trying to assign an existing IT admin",
              messageType: "warning",
            })
          );
        } else {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: "IT admin assigned",
              messageType: "success",
            })
          );
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const handleChangeCategory = () => {
    const data = JSON.stringify({
      intSubCategory: intSubCategory,
      intTicketID: parseInt(ticketID),
      intSPType: 11,
    });
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    axios(config)
      .then(function (response) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Category has been changed",
            messageType: "success",
          })
        );
        setTimeout(function () {
          window.location.reload();
        }, 1000);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const handleAssignVendor = () => {
    let description = "";
    let attachment = "";

    if (toggleState) {
      description = txtVendorDescription;
      attachment = txtVendorAttachment;
    }

    const data = JSON.stringify({
      intSubCategory: intVendorID,
      txtDescription: description,
      txtAttachment: attachment,
      intTicketID: parseInt(ticketID),
      intSPType: 12,
    });
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    axios(config)
      .then(function (response) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "Vendor assigned",
            messageType: "success",
          })
        );

        const found = vendorList.find((obj) => {
          return obj.id === intVendorID;
        });
        setVendorName(found.vendor_name);
        setVendorDescription(found.ticket_description);
        setVendorAttachment(found.ticket_attachment);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const [ticketStatusID, setTicketStatusID] = useState(0);
  const [repeatedTicketID, setRepeatedTicketID] = useState(0);
  const handleTicketStatusChange = (review = 0) => {
    const selectedStatus = ticketStatusList.find(s => s.id === ticketStatusID);
    // if (selectedStatus?.name?.toLowerCase().includes("close") && review === 0) {
    //   setOpenFeedback(true);
    //   return;
    // }

    const data = JSON.stringify({
      intStatusID: ticketStatusID,
      intTicketID: parseInt(ticketID),
      intUserID: userData.id,
      intSPType: 19,
      intReview: review,
    });
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    axios(config)
      .then(function (response) {
        setOpenFeedback(false);
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          })
        );

        const found = vendorList.find((obj) => {
          return obj.id === intVendorID;
        });
        setVendorName(found?.vendor_name || "");

        if (selectedStatus?.name?.toLowerCase().includes("close")) {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const handleTicketRepeated = () => {
    const data = JSON.stringify({
      intStatusID: repeatedTicketID,
      intTicketID: parseInt(ticketID),
      intUserID: userData.id,
      intSPType: 20,
    });
    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;
    axios(config)
      .then(function (response) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          })
        );

        const found = vendorList.find((obj) => {
          return obj.id === intVendorID;
        });
        setVendorName(found.vendor_name);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  useEffect(() => {
    if (updateRef.current === false) {
      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "1",
      });
      config.method = "PATCH";
      config.data = data;
      config.url = ticketAPI;
      axios(config)
        .then(function (response) {
          setIssueTypeList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      return () => {
        updateRef.current = true;
      };
    }
  }, []);

  const options = issueTypeList.map((option) => {
    const firstLetter = option.category;
    return {
      firstLetter: firstLetter,
      ...option,
    };
  });

  const optionsAgent = agentList.map((option) => {
    if (option.name !== null) {
      const firstLetter = option.name[0].toUpperCase();
      return {
        firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
        ...option,
      };
    }
  });

  const vendorOptions = vendorList.map((option) => {
    const firstLetter = option.vendor_name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });

  const [assetsList, setAssetsList] = useState([]);
  const fetchAssets = () => {
    const data = JSON.stringify({
      intTicketID: parseInt(ticketID),
      txtAssets: "",
      intIssueSubType: intIssueSubType,
      intSPType: 3,
    });

    config.method = "PATCH";
    config.data = data;
    config.url = assetsAPI;
    axios(config)
      .then(function (response) {
        setAssetsList([]);
        if (response.data.data.length > 0) {
          setAssetsList(JSON.parse(response.data.data[0].assets));
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
      });
  };

  const handleReplyButtonClick = () => {
    setOpenStatusDialog(true);
  };

  const handleStatusSelect = (statusID) => {
    // For "Open", the user specifically requested to pass 49
    const finalStatusID = statusID === 45 ? 49 : statusID;
    handleReply(finalStatusID);
  };

  const handleReply = (statusID) => {
    const description = getInnerHtml("txtDescription");
    if (!cleanText(description) && files.length === 0) {
      childRef.current.triggerAlert(
        JSON.stringify({
          message: "Please enter a message or attach a file.",
          messageType: "warning",
        })
      );
      setIsReplying(false);
      return;
    }
    setIsReplying(true);
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file[]", file);
    });
    formData.append("intUserID", userData.id);
    formData.append("intTicketID", parseInt(ticketID));
    formData.append("txtDescription", getInnerHtml("txtDescription"));
    formData.append("intStatusID", statusID); // Passing the selected status ID
    formData.append("intSPType", 4);

    var config1 = {
      method: "PATCH",
      url: userDashboardAPI,
      mode: "cors",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + userData.token,
      },
      data: formData,
      onUploadProgress: (event) => {
        console.log(
          `Current progress:`,
          Math.round((event.loaded * 100) / event.total)
        );
      },
    };

    setIsLoadingSubmit(true);

    axios(config1)
      .then(function (response) {
        console.log(response);
        setIsReplying(false);
        setTimeout(function () {
          window.location.reload();
        }, 2000);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsReplying(false);
      })
      .finally(() => {
        setIsLoadingSubmit(false);
        setOpenStatusDialog(false);
      });
  };

  const [selectedTicketDescription, setSelectedTicketDescription] =
    useState("");

  const handleApprovalSubmit = (description) => {
    if (!approvalStatus) {
      alert("Please select Approve or Decline.");
      return;
    }

    if (approvalStatus === "Decline" && !declineReason.trim()) {
      alert("Please enter a reason for decline.");
      return;
    }

    const plainTextDescription = description.replace(/&nbsp;/g, " ");

    const data = JSON.stringify({
      intTicketID: parseInt(ticketID),
      txtDescription: plainTextDescription,
      intUserID: userData.id,
      intSPType: 22,
      txtStatus: approvalStatus,
      txtDeclineReason:
        approvalStatus === "Decline" ? declineReason.trim() : "",
    });

    config.method = "POST";
    config.data = data;
    config.url = agentDashboardAPI;

    setIsLoadingSubmit(true);

    axios(config)
      .then(function (response) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: response.data.message,
            messageType: "success",
          })
        );

        setApprovalStatus("");
        setDeclineReason("");
        setTimeout(function () {
          window.location.reload();
        }, 2000);
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log("Approval Error:", error);
      })
      .finally(() => setIsLoadingSubmit(false));
  };

  const cleanText = (text) =>
    text
      ?.replace(/<[^>]+>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  let approvalReached = false;
  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isLoadingSubmit}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <AlertMessage ref={childRef} />
      <Grid container marginTop="30px">
        <Grid item xs={12} lg={9} md={12} className="content-details">
          {ticketData.length > 0 ? (
            <>
              {ticketData.map((row, index) => {
                const cleanRowDesc = cleanText(row.ticket_description);
                const isMatched = statusDataList.find(
                  (item) => item.ticket_description?.trim() === cleanRowDesc
                );
                return (
                  <div key={index}>
                    <div>
                      <Typography variant="h4" fontWeight="600">
                        {row.ticketSubject}
                      </Typography>
                      {index === 0 ? (
                        <Grid
                          marginTop={`20px`}
                          display={`flex`}
                          gap={`10px`}
                          alignItems={`center`}
                        >
                          <Typography fontWeight={`600`} fontSize={`16px`}>
                            Ticket ID:
                          </Typography>
                          <Typography fontWeight={`500`} fontSize={`16px`}>
                            {row.ticketID}
                          </Typography>
                          <FiberManualRecordIcon sx={{ fontSize: 7 }} />

                          <Typography fontWeight={`600`} fontSize={`16px`}>
                            Category:
                          </Typography>
                          <Typography fontWeight={`500`} fontSize={`16px`}>
                            {row.ticketCategory}
                          </Typography>
                          <FiberManualRecordIcon sx={{ fontSize: 7 }} />

                          <Typography fontWeight={`600`} fontSize={`16px`}>
                            Sub Category:
                          </Typography>
                          <Typography fontWeight={`500`} fontSize={`16px`}>
                            {row.sub_category}
                          </Typography>
                          <FiberManualRecordIcon sx={{ fontSize: 7 }} />

                          <Typography fontWeight={`600`} fontSize={`16px`}>
                            Prioritization:
                          </Typography>
                          <Typography fontWeight={`500`} fontSize={`16px`}>
                            {row.ticketType}
                          </Typography>
                        </Grid>
                      ) : (
                        <></>
                      )}
                      {index === 0 && (() => {
                        const agentFlow = ticketData
                          .filter(r => r.role === "1" || r.role === "2")
                          .map(r => r.name)
                          .reverse()
                          .filter((name, i, arr) => i === 0 || arr[i - 1] !== name);

                        return agentFlow.length > 0 ? (
                          <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", mt: 1, mb: 1 }}>
                            {agentFlow.map((agentName, i) => (
                              <React.Fragment key={i}>
                                <Typography sx={{ color: "#7b1fa2", fontWeight: 600, fontSize: "14px" }}>
                                  {agentName}
                                </Typography>
                                {i < agentFlow.length - 1 && (
                                  <Box component="span" sx={{ color: "#7b1fa2", fontWeight: 700, fontSize: "14px", verticalAlign: "middle", position: "relative", top: "-1px" }}>→</Box>
                                )}
                              </React.Fragment>
                            ))}
                          </Box>
                        ) : null;
                      })()}
                      <Typography variant="span" fontSize="16px" color={`red`}>
                        {row.new_sub_category_name !== "" &&
                          row.new_sub_category_name !== null ? (
                          `(This ticket category has been changed ${row.sub_category} to ${row.new_sub_category_name})`
                        ) : (
                          <></>
                        )}
                      </Typography>
                      <div className="empty-space-20"></div>
                      <Grid
                        display="flex"
                        gap="10px"
                        alignItems={`center`}
                        justifyContent={`space-between`}
                        sx={{
                          flexDirection: { xs: "column", md: "row" },
                          mr: 1,
                        }}
                      >
                        <Grid display="flex" gap="10px" alignItems={`center`}>
                          <UserAvatar name={row.reply_type === "Vendor" ? row.vendor_name : row.ticketCreatedUserName} />
                          <Grid>
                            <Typography>
                              {index === 0 ? <>Created by </> : <>Replied by</>}{" "}
                              <strong>
                                {row.reply_type === "Vendor"
                                  ? `${row.vendor_name} (Vendor)`
                                  : row.ticketCreatedUserName}
                              </strong>
                            </Typography>
                            <Typography>
                              {moment
                                .utc(row.created_at)
                                .utcOffset("+05:30")
                                .format("MMM DD, YYYY, hh:mm A")}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      {row.ticket_attachment && row.ticket_attachment !== "" ? (
                        <Box display="flex" flexWrap="wrap" gap="10px" sx={{ mt: 2, mb: 1 }}>
                          {row.ticket_attachment.split(",").map((url, i) => {
                            const fileName = url.substring(url.lastIndexOf("/") + 1);
                            const displayName = fileName.includes("_") ? fileName.substring(fileName.indexOf("_") + 1) : fileName;
                            return (
                              <a
                                key={i}
                                href={url}
                                target={"_blank"}
                                className={`btn-download`}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '8px',
                                  minWidth: '220px',
                                  maxWidth: '280px',
                                  height: '42px',
                                  justifyContent: 'center',
                                  padding: '0 15px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap'
                                }}
                                title={decodeURIComponent(displayName)}
                              >
                                <DownloadIcon sx={{ fontSize: 18 }} />
                                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                  {decodeURIComponent(displayName)}
                                </span>
                              </a>
                            );
                          })}
                        </Box>
                      ) : (
                        <></>
                      )}

                      <div className="empty-space-20"></div>
                      <Grid>
                        <Typography
                          dangerouslySetInnerHTML={{
                            __html: row.ticket_description,
                          }}
                        ></Typography>
                      </Grid>
                    </div>
                    <div className="empty-space-20"></div>
                    {userData?.departmenthead === 1 &&
                      (() => {
                        if (
                          !approvalReached &&
                          isMatched?.status === "Approve"
                        ) {
                          approvalReached = true;
                          return (
                            <Accordion
                              className="accordion-box-shadow reply-section"
                              expanded={expanded === `panel${index}`}
                              onChange={handleChange(`panel${index}`)}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}a-content`}
                                id={`panel${index}-header`}
                              >
                                <Typography color="success.main">
                                  Approved
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Box
                                  sx={{
                                    backgroundColor: "#e6f4ea",
                                    border: "1px solid #a5d6a7",
                                    borderRadius: "8px",
                                    padding: "12px",
                                    marginBottom: "16px",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="success.main"
                                    fontWeight="bold"
                                  >
                                    Approved
                                  </Typography>
                                </Box>
                              </AccordionDetails>
                            </Accordion>
                          );
                        }

                        if (approvalReached) {
                          return null;
                        }

                        if (isMatched?.status === "Decline") {
                          return (
                            <Accordion
                              className="accordion-box-shadow reply-section"
                              expanded={expanded === `panel${index}`}
                              onChange={handleChange(`panel${index}`)}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}a-content`}
                                id={`panel${index}-header`}
                              >
                                <Typography color="error.main">
                                  Declined
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Box
                                  sx={{
                                    backgroundColor: "#f9eaea",
                                    border: "1px solid #e0b4b4",
                                    borderRadius: "8px",
                                    padding: "12px",
                                    marginBottom: "16px",
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    color="error"
                                    fontWeight="bold"
                                  >
                                    Decline Reason:
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    {isMatched.decline_reason}
                                  </Typography>
                                </Box>
                              </AccordionDetails>
                            </Accordion>
                          );
                        }

                        return (
                          <Accordion
                            className="accordion-box-shadow reply-section"
                            expanded={expanded === `panel${index}`}
                            onChange={handleChange(`panel${index}`)}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`panel${index}a-content`}
                              id={`panel${index}-header`}
                            >
                              <Typography>Approve or Decline</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <FormControl className="form-control" fullWidth>
                                <InputLabel>Approve / Decline</InputLabel>
                                <Select
                                  label="Approve / Decline"
                                  value={approvalStatus || ""}
                                  onChange={(e) =>
                                    setApprovalStatus(e.target.value)
                                  }
                                  displayEmpty
                                >
                                  <MenuItem value="Approve">Approve</MenuItem>
                                  <MenuItem value="Decline">Decline</MenuItem>
                                </Select>
                              </FormControl>

                              {approvalStatus === "Decline" && (
                                <FormControl
                                  className="form-control"
                                  fullWidth
                                  sx={{ mt: 2 }}
                                >
                                  <TextField
                                    label="Decline Reason"
                                    value={declineReason}
                                    onChange={(e) =>
                                      setDeclineReason(e.target.value)
                                    }
                                    multiline
                                    rows={3}
                                  />
                                </FormControl>
                              )}

                              <Grid
                                display="flex"
                                gap="20px"
                                justifyContent="flex-end"
                                sx={{ mt: 2 }}
                              >
                                <Button
                                  className="btn-primary"
                                  onClick={() => {
                                    if (
                                      approvalStatus === "Decline" &&
                                      !declineReason.trim()
                                    ) {
                                      alert(
                                        "Please enter a reason for decline."
                                      );
                                      return;
                                    }
                                    setSelectedTicketDescription(
                                      row.ticket_description
                                    );
                                    handleApprovalSubmit(
                                      row.ticket_description
                                    );
                                  }}
                                >
                                  {approvalStatus === "Decline"
                                    ? "Decline"
                                    : "Approve"}
                                </Button>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })()}
                    {userData?.departmenthead === 0 &&
                      (isMatched && isMatched.status ? (
                        <Accordion
                          className="accordion-box-shadow reply-section"
                          expanded={expanded === `panel${index}`}
                          onChange={handleChange(`panel${index}`)}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`panel${index}a-content`}
                            id={`panel${index}-header`}
                          >
                            <Typography
                              color={
                                isMatched.status === "Decline"
                                  ? "error.main"
                                  : "success.main"
                              }
                            >
                              {isMatched.status === "Decline"
                                ? "Declined by Department Head"
                                : "Approved by Department Head"}
                            </Typography>
                          </AccordionSummary>

                          {isMatched.status === "Decline" && (
                            <AccordionDetails>
                              <Box
                                sx={{
                                  backgroundColor: "#f9eaea",
                                  border: "1px solid #e0b4b4",
                                  borderRadius: "8px",
                                  padding: "12px",
                                  marginBottom: "16px",
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  color="error"
                                  fontWeight="bold"
                                >
                                  Decline Reason:
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  {isMatched.decline_reason}
                                </Typography>
                              </Box>
                            </AccordionDetails>
                          )}
                          {isMatched.status === "Approve" && (
                            <AccordionDetails>
                              <Box
                                sx={{
                                  backgroundColor: "#e6f4ea",
                                  border: "1px solid #a5d6a7",
                                  borderRadius: "8px",
                                  padding: "12px",
                                  marginBottom: "16px",
                                }}
                              >
                                <Typography
                                  variant="subtitle2"
                                  color="success.main"
                                  fontWeight="bold"
                                >
                                  Approved
                                </Typography>
                              </Box>
                            </AccordionDetails>
                          )}
                        </Accordion>
                      ) : null)}

                    <div className="empty-space-20"></div>
                    <hr className="hrLine" />
                  </div>
                );
              })}
            </>
          ) : (
            <></>
          )}

          <div className="empty-space-20"></div>

          {(ticketData[0]?.review === null ||
            ticketData[0]?.review === undefined ||
            ticketData[0]?.review === "" ||
            Number(ticketData[0]?.review) === 0) && (
              <div className="reply-section">
                <Grid>
                  <TextEditor
                    id="txtDescription"
                    fullWidth
                    showHeadings={false}
                    showUndoRedo={false}
                    showJustify={false}
                  />
                </Grid>

                <Grid marginTop={`10px`}>
                  <input
                    type="file"
                    multiple
                    onChange={handleFileChange}
                    style={{ marginBottom: "10px" }}
                  />
                  {files.length > 0 && (
                    <div style={{ marginTop: "10px" }}>
                      <Typography variant="subtitle2" gutterBottom>
                        Selected Files:
                      </Typography>
                      <ul style={{ listStyle: "none", padding: 0 }}>
                        {files.map((f, index) => (
                          <li
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: "5px",
                              padding: "5px 10px",
                              backgroundColor: "#f5f5f5",
                              borderRadius: "4px",
                            }}
                          >
                            <Typography variant="caption">{f.name}</Typography>
                            <Button
                              size="small"
                              color="error"
                              onClick={() => handleRemoveFile(index)}
                              style={{ minWidth: "auto", padding: "2px 5px" }}
                            >
                              Remove
                            </Button>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </Grid>

                <div className="empty-space-20"></div>
                <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                  <Button
                    className="btn-primary"
                    onClick={handleReplyButtonClick}
                    startIcon={<SendIcon />}
                  >
                    Reply
                  </Button>
                </Grid>
              </div>
            )}

          <Dialog open={openStatusDialog} onClose={() => setOpenStatusDialog(false)}>
            <DialogTitle>Select Status for Reply</DialogTitle>
            <DialogContent>
              <List>
                {[
                  { id: 45, name: "Open" }, // Will be mapped to 49
                  { id: 48, name: "Closed" },
                  { id: 46, name: "On hold" },
                ].map((status) => (
                  <ListItem disablePadding key={status.id}>
                    <ListItemButton onClick={() => handleStatusSelect(status.id)}>
                      <ListItemText primary={status.name} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenStatusDialog(false)}>Cancel</Button>
            </DialogActions>
          </Dialog>
        </Grid>

        <Grid item xs={12} lg={3} md={12} marginTop={`30px`}>
          <Container>
            <Accordion
              className="accordion-box-shadow"
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Contact Details</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>Email</Typography>
                <Typography>
                  <strong>{contactDetails["email"]}</strong>
                </Typography>
                <div className="empty-space-30"></div>

                <Typography>Mobile</Typography>
                <Typography>
                  <strong>
                    {contactDetails["phone"] === `undefined`
                      ? "-"
                      : contactDetails["phone"]}
                  </strong>
                </Typography>
                <div className="empty-space-30"></div>

                <Typography>No of Ticket</Typography>
                <Typography>
                  <strong>{contactDetails["no_of_ticket"]}</strong>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              className="accordion-box-shadow"
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Timeline</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Timeline
                  sx={{
                    [`& .${timelineOppositeContentClasses.root}`]: {
                      flex: 0.2,
                    },
                  }}
                >
                  <TimelineItem className="timeline">
                    <TimelineOppositeContent color="textSecondary">
                      {ticketData.map((row, index) => {
                        return (
                          <div key={index}>
                            {" "}
                            {index === 0 ? (
                              <>
                                {moment
                                  .utc(row.created_at)
                                  .utcOffset("+05:30")
                                  .format("DD MMM Y")}
                                <br />
                                {moment
                                  .utc(row.created_at)
                                  .utcOffset("+05:30")
                                  .format("hh:mm A")}
                              </>
                            ) : (
                              ``
                            )}{" "}
                          </div>
                        );
                      })}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot className="open-ticket" />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>Open</TimelineContent>
                  </TimelineItem>

                  {timelineList.map((row, index) => (
                    <TimelineItem className="timeline" key={index}>
                      <TimelineOppositeContent color="textSecondary">
                        {moment
                          .utc(row.created_at)
                          .utcOffset("+05:30")
                          .format("DD MMM Y")}
                        <br />
                        {moment
                          .utc(row.created_at)
                          .utcOffset("+05:30")
                          .format("hh:mm A")}
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        <TimelineDot className="open-ticket" />
                        {timelineList.length - 1 !== index ? (
                          <TimelineConnector />
                        ) : (
                          ""
                        )}
                      </TimelineSeparator>
                      <TimelineContent>{row.name}</TimelineContent>
                    </TimelineItem>
                  ))}
                </Timeline>
              </AccordionDetails>
            </Accordion>

            {ticketData[0]?.ticket_status !== 48 && (
              <Accordion
                className={`accordion-box-shadow reply-section`}
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography>Change Category</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <FormControl className={`form-control`} fullWidth>
                    <Autocomplete
                      id="grouped-demo"
                      options={options}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.name}
                      fullWidth
                      renderInput={(params) => (
                        <TextField {...params} label="Category" />
                      )}
                      onChange={(event, newValue) => {
                        if (newValue !== null) {
                          intIssueSubType = newValue.id;
                          setSubCategory(newValue.id);
                        }
                      }}
                      className={` `}
                    />
                  </FormControl>

                  <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                    <Button
                      className="btn-primary"
                      onClick={handleChangeCategory}
                    >
                      Change Category
                    </Button>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )}

            {(userData.role === "agent" || userData.role === "Admin") &&
              ticketData[0]?.ticket_status !== 48 && (
                <Accordion
                  className={`accordion-box-shadow reply-section`}
                  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4a-content"
                    id="panel4a-header"
                  >
                    <Typography>Assign Vendor</Typography>
                  </AccordionSummary>

                  <AccordionDetails>
                    {vendorName === "" ? (
                      <>
                        <FormControl className={`form-control`} fullWidth>
                          <Autocomplete
                            id="grouped-demo"
                            options={vendorOptions}
                            groupBy={(option) => option.firstLetter}
                            getOptionLabel={(option) => option.vendor_name}
                            fullWidth
                            renderInput={(params) => (
                              <TextField {...params} label="Vendor" />
                            )}
                            onChange={(event, newValue) => {
                              if (newValue !== null) {
                                setVendorID(newValue.id);
                              }
                            }}
                          />
                          <Typography className="invalid-feedback">
                            {vendorNameError}
                          </Typography>
                        </FormControl>

                        <FormControl
                          className={`form-control`}
                          fullWidth
                          style={{ backgroundColor: "lightpurple" }}
                        >
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={toggleState}
                                  onChange={handleToggleChange}
                                />
                              }
                            />
                          </FormGroup>
                        </FormControl>

                        <FormControl className={`form-control`} fullWidth>
                          <TextField
                            id="outlined-multiline-static"
                            label="Vendor Message"
                            multiline
                            rows={4}
                            fullWidth
                            value={txtVendorDescription}
                            onChange={(e) => setVendorDescription(e.target.value)}
                          />
                        </FormControl>
                        <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                          <Button
                            className="btn-primary"
                            onClick={handleAssignVendor}
                            justifyContent={`flex-end`}
                          >
                            Update
                          </Button>
                        </Grid>
                      </>
                    ) : (
                      <>
                        <Typography fontWeight={`600`} fontSize={`18px`}>
                          Assigned Vendor Name{" "}
                        </Typography>
                        <Typography
                          variants="h4"
                          marginTop={2}
                          fontSize={`17px`}
                          fontWeight={`500`}
                        >
                          {vendorName}
                        </Typography>
                      </>
                    )}
                  </AccordionDetails>
                </Accordion>
              )}

            {(userData.role === "agent" || userData.role === "Admin") &&
              ticketData[0]?.ticket_status !== 48 && (
                <Accordion
                  className={`accordion-box-shadow reply-section`}
                  expanded={expanded === "panel5"}
                  onChange={handleChange("panel5")}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography>Assign IT Admin</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <FormControl className={`form-control`} fullWidth>
                      <Autocomplete
                        id="grouped-demo"
                        options={optionsAgent}
                        groupBy={(option) => option.firstLetter}
                        getOptionLabel={(option) => option.name}
                        fullWidth
                        renderInput={(params) => (
                          <TextField {...params} label="IT Admin" />
                        )}
                        onChange={(event, newValue) => {
                          if (newValue !== null) {
                            setAgentID(newValue.id);
                          }
                        }}
                        className={` `}
                      />
                    </FormControl>

                    <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                      <Button className="btn-primary" onClick={handleAssignAgent}>
                        Assign
                      </Button>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
              )}

            {/* panel6 - Change Status hidden as requested */}

            {/* panel7 - Mark as Repeated: now Searchable Autocomplete */}
            {ticketData[0]?.ticket_status !== 48 && (
              <Accordion
                className={`accordion-box-shadow reply-section`}
                expanded={expanded === "panel7"}
                onChange={handleChange("panel7")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <Typography>Mark as repeated</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Autocomplete
                    options={repetedTicketStatusList}
                    getOptionLabel={(option) => option.name || ""}
                    value={repetedTicketStatusList.find((r) => r.id === repeatedTicketID) || null}
                    onChange={(event, newValue) => setRepeatedTicketID(newValue ? newValue.id : 0)}
                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                    renderInput={(params) => (
                      <TextField {...params} label="Repeated Ticket" fullWidth />
                    )}
                    fullWidth
                  />

                  <Grid display="flex" gap="20px" justifyContent={`flex-end`}>
                    <Button
                      className="btn-primary"
                      onClick={handleTicketRepeated}
                    >
                      Assign
                    </Button>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )}
          </Container>
        </Grid>
      </Grid>
      {/* <Dialog open={openFeedback} onClose={() => setOpenFeedback(false)} maxWidth="sm" fullWidth>
        <DialogTitle textAlign="center" fontWeight="600">Give your Feedback</DialogTitle>
        <DialogContent>
          <Grid container justifyContent="center" spacing={4} sx={{ mt: 1, mb: 2 }}>
            <Grid item>
              <Box
                textAlign="center"
                sx={{ cursor: 'pointer', opacity: feedbackValue === 5 ? 1 : 0.5, transform: feedbackValue === 5 ? 'scale(1.1)' : 'scale(1)', transition: '0.3s' }}
                onClick={() => setFeedbackValue(5)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                  <g fill="none" fillRule="evenodd">
                    <path fill="#6BB437" fillOpacity=".3" stroke="#6BB437" strokeWidth="4.56" d="M56 29.5C56 14.864 44.136 3 29.5 3S3 14.864 3 29.5 14.864 56 29.5 56 56 44.136 56 29.5"></path>
                    <path stroke="#6BB437" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.56" d="M40.857 38.964c-7.571 5.679-15.143 5.679-22.714 0"></path>
                    <path fill="#6BB437" d="M43.696 23.729a4.732 4.732 0 10-9.464 0 4.732 4.732 0 009.464 0m-18.928 0a4.732 4.732 0 10-9.464 0 4.732 4.732 0 009.464 0"></path>
                  </g>
                </svg>
                <Typography fontWeight="600" color="#6BB437">Positive</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box
                textAlign="center"
                sx={{ cursor: 'pointer', opacity: feedbackValue === 3 ? 1 : 0.5, transform: feedbackValue === 3 ? 'scale(1.1)' : 'scale(1)', transition: '0.3s' }}
                onClick={() => setFeedbackValue(3)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                  <g fill="none" fillRule="evenodd">
                    <path fill="#FFD012" fillOpacity=".3" stroke="#FFD012" strokeWidth="4.56" d="M56 29.693c0-14.691-11.864-26.6-26.5-26.6S3 15.002 3 29.693c0 14.692 11.864 26.6 26.5 26.6S56 44.385 56 29.693"></path>
                    <path stroke="#FFD012" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4.56" d="M37.071 41H21.93"></path>
                    <path fill="#FFD012" d="M43.696 23.9c0-2.624-2.117-4.75-4.732-4.75-2.612 0-4.732 2.126-4.732 4.75 0 2.622 2.12 4.75 4.732 4.75 2.615 0 4.732-2.128 4.732-4.75m-18.928 0c0-2.624-2.118-4.75-4.732-4.75-2.612 0-4.732 2.126-4.732 4.75 0 2.622 2.12 4.75 4.732 4.75 2.614 0 4.732-2.128 4.732-4.75"></path>
                  </g>
                </svg>
                <Typography fontWeight="600" color="#FFB100">Neutral</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box
                textAlign="center"
                sx={{ cursor: 'pointer', opacity: feedbackValue === 1 ? 1 : 0.5, transform: feedbackValue === 1 ? 'scale(1.1)' : 'scale(1)', transition: '0.3s' }}
                onClick={() => setFeedbackValue(1)}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
                  <g fill="#FF5959" fillRule="evenodd">
                    <path fillOpacity=".3" stroke="#FF5959" strokeWidth="4.56" d="M56 29.693c0-14.691-11.864-26.6-26.5-26.6S3 15.002 3 29.693c0 14.692 11.864 26.6 26.5 26.6S56 44.385 56 29.693"></path>
                    <path fillRule="nonzero" d="M16.327 41.214c6.283-8.392 20.063-8.392 26.346 0a2.286 2.286 0 01-.451 3.192 2.266 2.266 0 01-3.18-.453c-4.466-5.964-14.618-5.964-19.083 0a2.266 2.266 0 01-3.18.453 2.266 2.266 0 01-.452-3.192z"></path>
                    <path d="M43.696 23.9c0-2.624-2.117-4.75-4.732-4.75-2.612 0-4.732 2.126-4.732 4.75 0 2.622 2.12 4.75 4.732 4.75 2.615 0 4.732-2.128 4.732-4.75m-18.928 0c0-2.624-2.118-4.75-4.732-4.75-2.612 0-4.732 2.126-4.732 4.75 0 2.622 2.12 4.75 4.732 4.75 2.614 0 4.732-2.128 4.732-4.75"></path>
                  </g>
                </svg>
                <Typography fontWeight="600" color="#FF5959">Negative</Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ pb: 3, pr: 3 }}>
          <Button onClick={() => setOpenFeedback(false)} color="inherit">Cancel</Button>
          <Button
            onClick={() => handleTicketStatusChange(feedbackValue)}
            className="btn-primary"
            disabled={feedbackValue === 0}
          >
            Submit Feedback
          </Button>
        </DialogActions>
      </Dialog> */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isReplying}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Layout>
  );
}